<template lang="pug">
.v-documents.documents(v-if="data")
	.container
		.documents__wrap
			.documents__head(v-if="data.title")
				.documents__head-title {{data.title}}
			.documents__list(v-if="data.items && data.items.length")
				template(v-for="(item, index) in data.items" :key="index" )
					.document__item
						.document
							.document__left
								.document__icon
									v-svg-icon.icon-folder(icon="folder")
								.document__title
									.document__name(v-if="item.name" ) {{ item.name }}
									.document__info
										span.document__type(v-if="item.type" ) {{ item.type }}
										span.document__separator |
										span.document__size(v-if="item.size" ) {{ item.size }}
							.document__right(v-if="item.link")
								a.document__link(
									:href="item.link?.href"
									download)
									| {{ item.link?.text }}
</template>

<script>
	import sourceMixin from '../components/mixins/v-mixin-source.vue';
	export default {
		mixins: [
			sourceMixin
		],
		data() {
			return {
				data: null
			}
		},
		methods: {
			dataSet(data) {
				this.data = data;
			}
		}
	}

</script>